import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DockType } from '@classes/dock-type';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DockTypeService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/dockType';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getDockTypes(): Observable<Array<DockType>> {
    return this.http.get<Array<DockType>>(this.basePath);
  }
}
